import { CDN_BASE_URL } from '../constants';

export type ShowreelItem = {
  id: string;
  title: string;
  src: string;
  poster?: string;
  tag?: string;
};

const reel = (filename: string) =>
  `${CDN_BASE_URL}${encodeURIComponent(`agent_reels/${filename}`).replace(/%2F/g, '/')}`;

export const SHOWREEL_ITEMS: ShowreelItem[] = [
  { id: 'door', title: 'Door', src: reel('Door.mp4') },
  { id: 'fantasy-world', title: 'Fantasy World', src: reel('Fantasy World.mp4') },
  { id: 'grandmother', title: 'Grandmother', src: reel('Grandmother.mp4') },
  { id: 'horror', title: 'Horror', src: reel('Horror.mp4') },
  { id: 'love-marriage', title: 'Love & Marriage', src: reel('Love & Marriage.mp4') },
  { id: 'pixar-fc', title: 'Pixar F&C', src: reel('Pixar F&C.mp4') },
  { id: 'sprint', title: 'Sprint', src: reel('Sprint.mp4') },
  { id: 'wolf', title: 'Wolf', src: reel('wolf.mp4') },
  { id: 'zombie', title: 'Zombie', src: reel('Zombie.mp4') },
];
